// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4354":"584a8cf041835bc7cb2d","4816":"584a8cf041835bc7cb2d"}[chunkId] + ".min.css";
};